<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <v-card
        flat
        width="100%"
        class="login-options">
        <!-- email address -->
        <ValidationProvider
          mode="eager"
          vid="email_address"
          name="auth.email"
          rules="required|email"
          v-slot="{ errors }">
          <v-text-field
            filled
            flat
            :disabled="waiting || loading"
            :maxlength="100"
            name="email"
            v-model="email"
            :error-messages="errors[0]"
            autocomplete="email"
            class="email-address mb-2"
            label="Correo electrónico"
            hide-details>
          </v-text-field>
        </ValidationProvider>
        <v-card-actions
          class="pa-0">
          <v-btn
            type="submit"
            width="100%"
            class="brand-purple white--text"
            :loading="waiting"
            :disabled="loading">
            INGRESAR CON EVENTEROS
          </v-btn>
        </v-card-actions>
        <v-divider class="my-6" />
        <login-with-social-button
          provider="google"
          @redirecting="$emit('update:loading', true)"
          :disabled="waiting || loading">
        </login-with-social-button>
        <login-with-social-button
          v-if="false"
          provider="facebook"
          @redirecting="$emit('update:loading', true)"
          :disabled="waiting || loading">
        </login-with-social-button>
      </v-card>
    </form>
  </ValidationObserver>
</template>

<script>

import LoginWithSocialButton from '@/components/Auth/LoginWithSocialButton.vue';

import loginController from '@/controllers/Login';

export default {
  name: 'LoginOptions',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    initialEmail: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      email: this.initialEmail,
      waiting: false,
    };
  },
  watch: {
    initialEmail(newVal) {
      this.email = newVal;
    },
    email(newVal) {
      const emailTrim = newVal.trim();
      if (emailTrim !== newVal) {
        this.email = emailTrim;
      }
    },
  },
  methods: {
    submit() {
      this.waiting = true;
      const { email } = this;
      loginController.checkEmail(email)
        .then(() => true)
        .catch(() => false)
        .then((exists) => {
          this.$emit('checked', {
            email,
            exists,
          });
          this.waiting = false;
        });
    },
  },
  components: {
    LoginWithSocialButton,
  },
};
</script>

<style lang="scss" scoped>
.login-options {
  .v-btn {
    width: 100%;
    height: 43px;
    font-weight: 400;
    font-size: 14px;
  }
}
</style>
